export default "__VITE_ASSET__l83n18j8__"